export default [{
  path: '/sdindex',
  name: 'sdindex',
  meta: {
    title: '首页'
  },
  component: () => import('@/pages/SDcallfee/blank')
}, {
  path: '/sdcallfee',
  name: 'sdcallfee',
  meta: {
    title: '首页',
    notShare: true
  },
  component: () => import('@/pages/SDcallfee/Index')
}, {
  path: '/sdregister',
  name: 'sdregister',
  meta: {
    title: '活动',
    notShare: true
  },
  component: () => import('@/pages/SDcallfee/Register')
}, {
  path: '/sdrechargeresult',
  name: 'sdrechargeresult',
  meta: {
    title: '充值结果',
    notShare: true
  },
  component: () => import('@/pages/SDcallfee/rechargeResult')
}, {
  path: '/sdqrcode',
  name: 'sdqrcode',
  meta: {
    title: '关注中国银行山东省分行',
    notShare: true
  },
  component: () => import('@/pages/SDcallfee/Qrcode')
}]



// WEBPACK FOOTER //
// ./src/router/SDindex.js